import { Provider } from 'react-redux'
import Routes from './routes/Routes'
import Toast from './Components/Toast'

import './App.css'
import store from './store'

function App() {
  return (
    <Provider store={store}>
      <Routes />
      <Toast />
    </Provider>
  )
}

export default App
